import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const CommunityTestimonials = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = {
    en: [
      {
        id: 1,
        name: "Layla Al-Rashid",
        role: "Fashion Creator",
        location: "Kuwait City, Kuwait",
        avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop",
        rating: 5,
        testimonial: `CreatorBridge didn't just help me monetize my content—it transformed my entire approach to creating. The cultural sensitivity training and local market insights helped me connect with brands that truly value authentic Middle Eastern fashion perspectives.`,
        achievement: "Increased earnings by 400%",
        campaigns: 23,
        verified: true
      },
      {
        id: 2,
        name: "Omar Khalil",
        role: "Tech Entrepreneur",
        location: "Riyadh, Saudi Arabia",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
        rating: 5,
        testimonial: `As a brand owner, finding creators who understand our regional market was challenging until CreatorBridge. The platform's verification system and cultural matching algorithm connected us with creators who delivered authentic engagement and measurable ROI.`,
        achievement: "300% ROI improvement",
        campaigns: 15,
        verified: true
      },
      {
        id: 3,
        name: "Fatima Hassan",
        role: "Food Content Creator",
        location: "Amman, Jordan",
        avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
        rating: 5,
        testimonial: `The community support on CreatorBridge is incredible. From skill development workshops to peer mentorship, I've grown not just as a creator but as a business owner. The platform truly invests in our success.`,
        achievement: "Built sustainable food brand",
        campaigns: 31,
        verified: true
      },
      {
        id: 4,
        name: "Ahmed Al-Mansouri",
        role: "Marketing Director",
        location: "Dubai, UAE",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
        rating: 5,
        testimonial: `CreatorBridge solved our biggest challenge: finding creators who could authentically represent our brand across different regional markets. The platform's analytics and fraud detection gave us confidence in our investments.`,
        achievement: "Expanded to 5 new markets",
        campaigns: 42,
        verified: true
      }
    ],
    ar: [
      {
        id: 1,
        name: "ليلى الراشد",
        role: "منشئة محتوى أزياء",
        location: "مدينة الكويت، الكويت",
        avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop",
        rating: 5,
        testimonial: `CreatorBridge لم يساعدني فقط في استثمار محتواي—بل غيّر نهجي بالكامل في الإبداع. التدريب على الحساسية الثقافية ورؤى السوق المحلية ساعدتني في التواصل مع العلامات التجارية التي تقدر حقاً وجهات النظر الأصيلة للأزياء الشرق أوسطية.`,
        achievement: "زيادة الأرباح بنسبة 400%",
        campaigns: 23,
        verified: true
      },
      {
        id: 2,
        name: "عمر خليل",
        role: "رائد أعمال تقني",
        location: "الرياض، السعودية",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
        rating: 5,
        testimonial: `كمالك علامة تجارية، كان العثور على مبدعين يفهمون السوق الإقليمي تحدياً حتى CreatorBridge. نظام التحقق في المنصة وخوارزمية المطابقة الثقافية ربطتنا بمبدعين حققوا تفاعلاً أصيلاً وعائد استثمار قابل للقياس.`,
        achievement: "تحسن العائد على الاستثمار بنسبة 300%",
        campaigns: 15,
        verified: true
      },
      {
        id: 3,
        name: "فاطمة حسن",
        role: "منشئة محتوى طعام",
        location: "عمان، الأردن",
        avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
        rating: 5,
        testimonial: `دعم المجتمع في CreatorBridge لا يصدق. من ورش تطوير المهارات إلى الإرشاد من الأقران، نمت ليس فقط كمبدعة بل كصاحبة أعمال. المنصة تستثمر حقاً في نجاحنا.`,
        achievement: "بناء علامة طعام مستدامة",
        campaigns: 31,
        verified: true
      },
      {
        id: 4,
        name: "أحمد المنصوري",
        role: "مدير التسويق",
        location: "دبي، الإمارات",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
        rating: 5,
        testimonial: `CreatorBridge حل أكبر تحدياتنا: العثور على مبدعين يمكنهم تمثيل علامتنا التجارية بأصالة عبر أسواق إقليمية مختلفة. تحليلات المنصة وكشف الاحتيال أعطانا الثقة في استثماراتنا.`,
        achievement: "التوسع إلى 5 أسواق جديدة",
        campaigns: 42,
        verified: true
      }
    ]
  };

  const testimonialsContent = {
    en: {
      title: "What Our Community Says",
      subtitle: "Real feedback from creators and brands who\'ve transformed their success through CreatorBridge",
      joinCommunity: "Join Our Community",
      viewAllStories: "View All Success Stories",
      verified: "Verified Member",
      campaigns: "campaigns completed"
    },
    ar: {
      title: "ما يقوله مجتمعنا",
      subtitle: "تعليقات حقيقية من المبدعين والعلامات التجارية الذين غيروا نجاحهم من خلال CreatorBridge",
      joinCommunity: "انضم لمجتمعنا",
      viewAllStories: "عرض جميع قصص النجاح",
      verified: "عضو معتمد",
      campaigns: "حملة مكتملة"
    }
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimonial((prev) => (prev + 1) % testimonials?.[currentLanguage]?.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [currentLanguage]);

  const content = testimonialsContent?.[currentLanguage];
  const currentTestimonials = testimonials?.[currentLanguage];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        color={index < rating ? "var(--color-warning)" : "var(--color-border)"}
        className={index < rating ? "fill-current" : ""}
      />
    ));
  };

  return (
    <section className={`py-20 bg-background ${currentLanguage === 'ar' ? 'rtl' : 'ltr'}`}>
      <div className="container mx-auto px-4">
        <div className={`text-center mb-16 ${currentLanguage === 'ar' ? 'text-right' : 'text-left'}`}>
          <h2 className="text-4xl font-bold text-foreground mb-4">
            {content?.title}
          </h2>
          <p className="text-xl text-muted-foreground max-w-4xl mx-auto">
            {content?.subtitle}
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Featured Testimonial */}
          <div className="card-elevated rounded-2xl p-8 lg:p-12 mb-12">
            <div className="grid lg:grid-cols-3 gap-8 items-center">
              <div className={`lg:col-span-2 space-y-6 ${currentLanguage === 'ar' ? 'text-right' : 'text-left'}`}>
                <div className="flex items-center space-x-1">
                  {renderStars(currentTestimonials?.[activeTestimonial]?.rating)}
                </div>
                
                <blockquote className="text-xl lg:text-2xl text-foreground leading-relaxed italic">
                  "{currentTestimonials?.[activeTestimonial]?.testimonial}"
                </blockquote>
                
                <div className="bg-success/10 border border-success/20 rounded-lg p-4 inline-block">
                  <p className="text-success font-semibold">
                    {currentTestimonials?.[activeTestimonial]?.achievement}
                  </p>
                </div>
              </div>

              <div className={`space-y-6 ${currentLanguage === 'ar' ? 'text-right' : 'text-left'}`}>
                <div className={`flex items-center space-x-4`}>
                  <div className="relative">
                    <Image
                      src={currentTestimonials?.[activeTestimonial]?.avatar}
                      alt={currentTestimonials?.[activeTestimonial]?.name}
                      className="w-16 h-16 rounded-full object-cover"
                    />
                    {currentTestimonials?.[activeTestimonial]?.verified && (
                      <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                        <Icon name="Check" size={12} color="white" />
                      </div>
                    )}
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-foreground">
                      {currentTestimonials?.[activeTestimonial]?.name}
                    </h4>
                    <p className="text-muted-foreground">
                      {currentTestimonials?.[activeTestimonial]?.role}
                    </p>
                    <p className="text-sm text-muted-foreground flex items-center space-x-1">
                      <Icon name="MapPin" size={12} />
                      <span>{currentTestimonials?.[activeTestimonial]?.location}</span>
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className={`flex items-center space-x-2 ${currentLanguage === 'ar' ? 'flex-row-reverse space-x-reverse' : ''}`}>
                    <Icon name="Shield" size={16} color="var(--color-primary)" />
                    <span className="text-sm text-muted-foreground">{content?.verified}</span>
                  </div>
                  <div className={`flex items-center space-x-2 ${currentLanguage === 'ar' ? 'flex-row-reverse space-x-reverse' : ''}`}>
                    <Icon name="Award" size={16} color="var(--color-accent)" />
                    <span className="text-sm text-muted-foreground">
                      {currentTestimonials?.[activeTestimonial]?.campaigns} {content?.campaigns}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Testimonial Navigation */}
          <div className="flex items-center justify-center space-x-4 mb-12">
            {currentTestimonials?.map((testimonial, index) => (
              <button
                key={testimonial?.id}
                onClick={() => setActiveTestimonial(index)}
                className={`relative transition-all duration-300 ${
                  index === activeTestimonial ? 'scale-110' : 'opacity-60 hover:opacity-80'
                }`}
              >
                <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                {index === activeTestimonial && (
                  <div className="absolute inset-0 rounded-full ring-2 ring-primary ring-offset-2" />
                )}
              </button>
            ))}
          </div>

          {/* Additional Testimonials Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {currentTestimonials?.slice(0, 3)?.map((testimonial, index) => (
              <div key={testimonial?.id} className="card-elevated p-6 hover-lift">
                <div className="space-y-4">
                  <div className="flex items-center space-x-1">
                    {renderStars(testimonial?.rating)}
                  </div>
                  
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    "{testimonial?.testimonial?.substring(0, 120)}..."
                  </p>
                  
                  <div className={`flex items-center space-x-3 ${currentLanguage === 'ar' ? 'flex-row-reverse space-x-reverse' : ''}`}>
                    <Image
                      src={testimonial?.avatar}
                      alt={testimonial?.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-semibold text-foreground text-sm">
                        {testimonial?.name}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {testimonial?.role}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <div className={`flex flex-col sm:flex-row gap-4 justify-center ${currentLanguage === 'ar' ? 'sm:flex-row-reverse' : ''}`}>
              <Link to="/community-showcase">
                <Button 
                  variant="default" 
                  size="lg"
                  iconName="Users"
                  iconPosition={currentLanguage === 'ar' ? 'right' : 'left'}
                >
                  {content?.joinCommunity}
                </Button>
              </Link>
              <Link to="/community-showcase">
                <Button 
                  variant="outline" 
                  size="lg"
                  iconName="ExternalLink"
                  iconPosition={currentLanguage === 'ar' ? 'right' : 'left'}
                >
                  {content?.viewAllStories}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityTestimonials;